import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import Link from 'src/components/ui/Link'
import useImageDistinguisher from 'src/utils/useImageDistinguisher'

import type { InfoCardCustomProps } from './Infocard-custom'

import './infoCardCustom.scss'

const InfoCardCustom = ({ desktop, sources, mobile }: InfoCardCustomProps) => {
  const { mobileImage, desktopImage } = useImageDistinguisher({ sources })
  const { isMobile } = useBreakpoint()

  const img = isMobile ? mobileImage : desktopImage
  const link = isMobile ? mobile.href : desktop.href
  const alt = isMobile ? mobile.alt : desktop.alt
  const marginTop = isMobile ? mobile.marginTop : desktop.marginTop
  const marginBottom = isMobile ? mobile.marginBottom : desktop.marginBottom

  return img ? (
    <section
      className="infocard"
      style={{
        marginTop: `${marginTop ?? '24px'}`,
        marginBottom: `${marginBottom ?? '24px'}`,
      }}
    >
      <Link as="a" href={link}>
        <div className="infocard-container">
          <img className="infocard-img" src={img} alt={alt} loading="lazy" />
        </div>
      </Link>
    </section>
  ) : (
    <></>
  )
}

export default InfoCardCustom
